import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Badge, Form, InputGroup } from 'react-bootstrap';
import logo from '../assets/Urbanwebhost-Logo_w.svg';

const Home = () => {
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    console.log('🏠 Home Page Loaded');
    console.log('📚 Welcome to React Teaching App!');
    console.log('🎯 Start learning React with 20 interactive lessons');
  }, []);

  const lessons = [
    { num: 1, title: "Components & JSX", desc: "Learn about functional, arrow, and class components with JSX syntax", level: "Beginner", category: "Fundamentals" },
    { num: 2, title: "Props", desc: "Master different ways to pass and use props in React components", level: "Beginner", category: "Fundamentals" },
    { num: 3, title: "State (useState)", desc: "Understand state management with the useState hook", level: "Beginner", category: "Fundamentals" },
    { num: 4, title: "useEffect Hook", desc: "Learn useEffect with different dependency array patterns", level: "Beginner", category: "Fundamentals" },
    { num: 5, title: "Conditional Rendering", desc: "Explore various patterns for conditional rendering", level: "Beginner", category: "Fundamentals" },
    { num: 6, title: "Lists & Keys", desc: "Render lists efficiently with proper key management", level: "Intermediate", category: "Core Concepts" },
    { num: 7, title: "Forms", desc: "Handle forms with controlled and uncontrolled components", level: "Intermediate", category: "Core Concepts" },
    { num: 8, title: "Event Handling", desc: "Master event handling patterns in React", level: "Intermediate", category: "Core Concepts" },
    { num: 9, title: "Context API", desc: "Share state across components with Context API", level: "Intermediate", category: "State Management" },
    { num: 10, title: "Redux vs Context", desc: "Compare Redux and Context API side-by-side", level: "Intermediate", category: "State Management" },
    { num: 11, title: "useReducer Hook", desc: "Manage complex state logic with useReducer", level: "Advanced", category: "Advanced Hooks" },
    { num: 12, title: "Custom Hooks", desc: "Create reusable custom hooks", level: "Advanced", category: "Advanced Hooks" },
    { num: 13, title: "useRef Hook", desc: "Work with refs for DOM manipulation and value persistence", level: "Advanced", category: "Advanced Hooks" },
    { num: 14, title: "useMemo Hook", desc: "Optimize performance with memoization", level: "Advanced", category: "Performance" },
    { num: 15, title: "useCallback Hook", desc: "Prevent unnecessary re-renders with useCallback", level: "Advanced", category: "Performance" },
    { num: 16, title: "Component Lifecycle", desc: "Understand lifecycle: class components vs hooks", level: "Advanced", category: "Advanced Concepts" },
    { num: 17, title: "API Integration", desc: "Fetch data from APIs with proper error handling", level: "Advanced", category: "Advanced Concepts" },
    { num: 18, title: "Error Boundaries", desc: "Handle errors gracefully with error boundaries", level: "Advanced", category: "Advanced Concepts" },
    { num: 19, title: "Lazy Loading", desc: "Optimize with code splitting and lazy loading", level: "Advanced", category: "Performance" },
    { num: 20, title: "Bootstrap in React", desc: "Use React Bootstrap components effectively", level: "Intermediate", category: "UI Framework" },
  ];

  const filteredLessons = lessons.filter(lesson =>
    lesson.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    lesson.desc.toLowerCase().includes(searchTerm.toLowerCase()) ||
    lesson.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getLevelColor = (level) => {
    switch (level) {
      case 'Beginner': return 'success';
      case 'Intermediate': return 'warning';
      case 'Advanced': return 'danger';
      default: return 'secondary';
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    console.log('🔍 Search term:', e.target.value);
  };

  return (
    <div>
      <div className="home-hero">
        <img src={logo} alt="Urban Web .Host" className="home-hero-logo mb-3" style={{height:48}} />
        <h1>🎓 React Teaching Application</h1>
        <p>Master React through 20 comprehensive, interactive lessons</p>
        <p className="mb-0">
          <Badge bg="light" text="dark" className="me-2">20 Lessons</Badge>
          <Badge bg="light" text="dark" className="me-2">Interactive Examples</Badge>
          <Badge bg="light" text="dark">Console Logging</Badge>
        </p>
      </div>

      <div className="mb-4">
        <InputGroup>
          <InputGroup.Text>🔍</InputGroup.Text>
          <Form.Control
            type="text"
            placeholder="Search lessons by title, description, or category..."
            value={searchTerm}
            onChange={handleSearch}
          />
        </InputGroup>
      </div>

      <Row>
        {filteredLessons.map((lesson) => (
          <Col md={6} lg={4} key={lesson.num} className="mb-4">
            <Link to={`/lesson${lesson.num}`} style={{ textDecoration: 'none' }}>
              <Card className="lesson-card h-100">
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <span>
                    <span className="lesson-number" style={{ width: '35px', height: '35px', lineHeight: '35px', fontSize: '0.9em' }}>
                      {lesson.num}
                    </span>
                    <strong>{lesson.title}</strong>
                  </span>
                  <Badge bg={getLevelColor(lesson.level)}>{lesson.level}</Badge>
                </Card.Header>
                <Card.Body>
                  <Card.Text className="text-muted">{lesson.desc}</Card.Text>
                  <Badge bg="secondary" className="mt-2">{lesson.category}</Badge>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>

      {filteredLessons.length === 0 && (
        <div className="text-center py-5">
          <h3>No lessons found</h3>
          <p className="text-muted">Try adjusting your search term</p>
        </div>
      )}

      <div className="mt-5">
        <Card>
          <Card.Header>
            <h5 className="mb-0">🚀 Getting Started</h5>
          </Card.Header>
          <Card.Body>
            <ol>
              <li>Choose a lesson from above to begin learning</li>
              <li>Open your browser console (Press F12 or Cmd+Option+I on Mac)</li>
              <li>Interact with examples and watch the console for detailed logs</li>
              <li>Each lesson includes visual examples and console outputs</li>
              <li>Progress from Beginner to Advanced topics systematically</li>
            </ol>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default Home;
